import { useState } from 'react';

import MobileNumberInput from '../mobile-number-input/MobileNumberInput';
import { MoveToCofeeContact } from './types';
import useSupportedPhoneCountries from './useSupportedPhoneCountries';
import { isMoveToCofeeMobileInvalid } from './validation';

interface MoveToCofeeMobileFieldProps {
  mobileNumber: string;
  countryCode: string;
  onChange: (
    data: Partial<Pick<MoveToCofeeContact, 'mobileNumber' | 'countryCode'>>
  ) => void;
}

const MoveToCofeeMobileField = ({
  mobileNumber,
  countryCode,
  onChange
}: MoveToCofeeMobileFieldProps) => {
  const supportedCountries = useSupportedPhoneCountries();
  // A pre-filled number is validated upfront so an invalid synced number
  // explains the disabled Continue button.
  const [isTouched, setIsTouched] = useState(!!mobileNumber);

  const showError =
    isTouched &&
    isMoveToCofeeMobileInvalid(mobileNumber, countryCode, supportedCountries);

  return (
    <MobileNumberInput
      label="Mobile number"
      isRequired
      countryCode={countryCode}
      phoneNumber={mobileNumber}
      onPhoneNumberChange={(value) => {
        setIsTouched(false);
        onChange({ mobileNumber: value });
      }}
      onPhoneNumberBlur={() => setIsTouched(true)}
      onCountryCodeChange={(value) => {
        setIsTouched(true);
        onChange({ countryCode: value });
      }}
      error={showError}
      errorMessage={
        mobileNumber
          ? 'Please enter a valid mobile number'
          : 'Mobile number is required'
      }
      usePortal
    />
  );
};

export default MoveToCofeeMobileField;
